import { useMemo } from 'react'

import { useNumericParams } from '@domain-group/react-hooks'

import { ModalContext } from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'

import handleCallbackAction from '@functions/handleCallbackAction'
import type { HandleCallbackActionParams } from '@functions/handleCallbackAction'

import useModals from '@hooks/useModals'

import PageContent from './components/PageContent'

const Details = () => {
  const { userId } = useNumericParams()

  const modalContext = useModals()
  const {
    callbacks: { },
  } = modalContext

  const pageContext = useMemo(() => ({
    callbacks: {
      updateUser: (payload: HandleCallbackActionParams) => handleCallbackAction(payload),
    },
  }), [])

  return (
    <PageContext.Provider value={pageContext}>
      <ModalContext.Provider value={modalContext}>
        <PageContent userId={userId} />
      </ModalContext.Provider>
    </PageContext.Provider>
  )
}

export default Details
